module.exports = __webpack_public_path__ + "static/media/tm.f2dc59b2.svg";